<template>
  <div
    v-editable.html="resource.columns.title"
    :class="[ open ? 'sponsorship__tab--open' : null ]"
    class="sponsorship__tab"
    @click="$emit('toggle')"
  />
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [editable],
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>
